import { Stack } from "@fluentui/react";
import React from "react";
import { IQuestionControlProps } from "shared/containers";

export const StackControl: React.FC<IQuestionControlProps> = (props) => {
	const { value } = props;
	return <Stack>{value}</Stack>;
};
